import React, { useEffect  } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { SortOrder } from "antd/lib/table/interface";
import { Layout, Table, Pagination } from 'antd';
import { AuthButton } from '../../core/CoreForm'
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from '../../core/CorePageContents'
import * as Module from '../../../modules/prime/mutual-aid/mutualAidModule';
import * as Model from '../../../modules/prime/mutual-aid/mutualAidModel';
import { initMessages } from '../../../modules/core/commonMessageModule';
import * as CONSTANTS from '../../../constants/constants';
import * as formatUtils from "../../../utils/formatUtils";
import AuthButtonStyles from '../../core/css/AuthButton.module.css';
import { initApiResult } from '../../../modules/core/bffApiModule';

interface titleInterface {
  title: string;
}

export const MutualAidResult = (props: titleInterface) => {

  const dispatch = useDispatch();
  let dataList = useSelector(Module.storedResultDataList);
  let total = useSelector(Module.storedResultDataListTotal);
  let criteria = useSelector(Module.storedResultListCriteria);
  let history = useHistory();

  useEffect(() => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    dispatch(Module.getResultListAsync(criteria));
  },
    [criteria]
  );

  const columns = [
    {
      title: "連携日",
      key: "1",
      width: 100,
      sortOrder: (criteria.sortItem !== "1") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidResultListRow) => {
        return (
          <>
            {<div >{formatUtils.formatDateSlash(row.linkedDatetime)}</div>}
          </>
        )
      }
    },
  ];

  /**
   * 検索条件を設定
   * @param keyValueList 
   */
  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.MutualAidResultListCriteria = {
      sortItem: criteria.sortItem,
      sortOrder: criteria.sortOrder,
      offset: criteria.offset,
      limit: criteria.limit,
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setResultListCriteria(newCriteria));
  }

  /**
   * テーブル検索条件変更時イベント（ソート）
   * @param sorter
   */
  const handleTableChange = (sorter: any) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let order = "";
    if (sorter.order === "ascend") {
      order = "0";
    } else if (sorter.order === "descend") {
      order = "1";
    }
    let sortItem = sorter.columnKey
    if (typeof sorter.column === "undefined") {
      sortItem = "";
    }

    criteriaDataTransfer([
      { key: "sortItem", value: sortItem }
      , { key: "sortOrder", value: order }
      , { key: "limit", value: criteria.limit }
      , { key: "offset", value: 0 } // ソート切替時は1ページ目から表示
    ])
  }

  /**
   * ページ変更時イベント（ページ、表示件数）
   * @param pagination
   * @param filters
   */
  const handlePaginationChange = (page: any, pageSize: any) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let offsetReset: boolean = false;
    if (criteria.limit !== pageSize) {
      offsetReset = true;
    }

    criteriaDataTransfer([
      { key: "sortItem", value: criteria.sortItem }
      , { key: "sortOrder", value: criteria.sortOrder }
      , { key: "limit", value: pageSize }
      , { key: "offset", value: offsetReset ? 0 : (page - 1) * pageSize }
    ])
  }

  /**
   * 明細画面へ遷移
   * @param record 
   * @returns 
   */
  const moveToDetail = (record: Model.MutualAidResultListRow) => {

    dispatch(Module.prepareMoveToResultDetailCriteria(record));

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_RESULT_DETAIL);
    return <></>;
  }

  /**
   * 戻るボタン押下
   */
  const onClickBack = () => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_PROJECT_LIST);
    return <></>;
  }

  // フッターボタンエリアを描画します。
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          onClick={onClickBack}
          className={AuthButtonStyles.backButtonFixed}
          style={{ margin: "10px" }}
        />
      </FooterButtonArea>
    )
  }

  return (

    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        <CommonMessage searchNoDataName="連携結果" />
        {
          total > 0 && dataList.length > 0 && dataList[0].key !== '' ?
            <>
              <div style={{maxWidth: "60%", minWidth: "600px"}}>
              <div className={"topPagination"}>
                <Pagination
                  className={"commonPagination topLeftPagination"}
                  defaultPageSize={10}
                  pageSize={criteria.limit}
                  pageSizeOptions={["5", "10", "20", "50", "100"]}
                  showSizeChanger={true}
                  showTotal={() => (<span>１ページあたりの表示件数</span>)}
                  locale={{ items_per_page: "件/ページ" }}
                  onChange={handlePaginationChange}
                  onShowSizeChange={(page, size) => {
                    handlePaginationChange(page, size); // ページサイズ変更時に1ページ目へ戻す
                  }}
                />
                <Pagination
                  className={"commonPagination topRightPagination"}
                  total={total}
                  current={criteria.offset / criteria.limit + 1}
                  pageSize={criteria.limit}
                  showTotal={(total) => <><span>{total.toLocaleString()}</span> 件数中、<span>{(criteria.offset + 1).toLocaleString()}</span> － <span>{total <= criteria.offset + criteria.limit ? total.toLocaleString() : (criteria.offset + criteria.limit).toLocaleString()}</span> 件</>}
                  onChange={handlePaginationChange}
                />
              </div>
              <Table
                size="small"
                sticky={{ offsetHeader: -31 }}
                columns={columns}
                dataSource={dataList}
                pagination={false}
                onChange={(pagination, filters, sorter) => handleTableChange(sorter)}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: () => {
                      moveToDetail(record)
                    }
                  };
                }}
              >
              </Table>
              <Pagination
                className={"commonPagination bottomPagination"}
                total={total}
                current={criteria.offset / criteria.limit + 1}
                pageSize={criteria.limit}
                onChange={handlePaginationChange}
              />
              </div>
            </>
            : <></>
        }
      </Content>
      <ButtonArea />
      <Footer />
    </Layout>
  );
}
